import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectFormattingOption')(function selectFormattingOption(formatOption, isSet, state) {
    var optionState = state.optionState;
    optionState[formatOption] = isSet;
}));
//# sourceMappingURL=selectFormattingOption.js.map